import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
`

export const Label = styled.div`
  flex-grow: 2;
  font: normal normal bold 14px/24px Inter;
  color: ${props => props.theme.colors.color6b7786};
`

export const Name = styled.span``
export const Description = styled.span``
